module.exports = __webpack_public_path__ + "img/portrait-023.fd23d311.jpg";